import {useTranslation} from "react-i18next";
import {SwalAlertClass} from "core/swalClass";
import {useEffect, useState} from "react";
import FormParams from "./models/form/FormParams";

const TableParams = ({item, setItem, modes, _TC}) => {
    const [t] = useTranslation("forms");
    const Alert = new SwalAlertClass({confirmButtonText: _TC("button.accept")});

    useEffect(() => {
        if (item.model && item.model in modes.current) {
            let item_ = {...item};
            item_.values = {...modes.current[item.model].values};
            item_.has = {...modes.current[item.model].has};
            setItem({...item_});
        }
    }, [item.model]);

    const onChangeParams = (e) => {
        let {name, value, type} = e.target;
        let item_ = {...item};
        if (type === "checkbox") {
            item_[name] = e.target.checked;
        } else {
            item_[name] = value;
        }
        setItem(item_);
    };

    const onChangeCheck = (e) => {
        let {name, checked} = e.target;
        let item_ = {...item};
        item_[name] = checked;
        setItem(item_);
    };

    const onBlurParams = (e) => {
        const {title, name} = e.target;
        let value = parseInt(e.target.value);
        let min = parseInt(e.target.min);
        let max = parseInt(e.target.max);
        if (value < min || max < value) {
            Alert.warning(title, _TC("message.value.range").replace("{min}", min).replace("{max}", max));
            setItem({...item, [name]: e.target.dataset.default});
            e.target.focus();
        }
    };

    return (
        <>
            <div className="col-12 mb-5">
                <table className="table table-striped mb-5">
                    <thead>
                        <tr>
                            <th>{t("common.name")}</th>
                            <th>{t("common.description")}</th>
                            <th className="text-center">{_TC("params")}</th>
                            <th style={{width: "35px", textAlign: "center"}}>{_TC("active")}</th>
                            <th style={{width: "35px", textAlign: "center"}}>{_TC("updated")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{_TC("fields.no_send")}</td>
                            <td>{_TC("fields.no_send.description")}</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="days" className="form-label">
                                                {_TC("fields.no_send.params")}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-4 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="days"
                                            name="days"
                                            className="mb-2 form-control text-end"
                                            required={true}
                                            min="1"
                                            max="7"
                                            step="1"
                                            title={_TC("days")}
                                            data-default="3"
                                            value={item.days}
                                            onChange={onChangeParams}
                                            onBlur={onBlurParams}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td className="text-center-middle">
                                <div className="form-switch">
                                    <input
                                        name="has_not_send"
                                        type="checkbox"
                                        id="has_not_send"
                                        className="form-check-input"
                                        checked={item.has_not_send}
                                        onChange={onChangeCheck}
                                    />
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        <FormParams item={item} _TC={_TC} />
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default TableParams;
